export class SessionListItem {
    constructor(
        public id: string,
        public name: string,
        public workout: string,
        public workoutId: string,
        public drill: string,
        public createdAt: string,
        public status: string
    ) { }
}
